module.exports = __webpack_public_path__ + "img/3.0fd6e7b4.jpeg";